// extracted by mini-css-extract-plugin
module.exports = {"new_post":"NewPost_new_post__2AfRl","header":"NewPost_header__mmjeR"};